import api from "./api";

export interface PublicRegistrationField {
  key: string;
  label: string;
  required: boolean;
  type: string;
}

export interface PublicRegistrationMeta {
  company: {
    id: number;
    name: string;
    logo_url?: string | null;
    address?: string | null;
  };
  fields: PublicRegistrationField[];
  linked_forms_count: number;
  will_send_forms: boolean;
}

export interface PublicRegistrationResult {
  customer: {
    id: number;
    name: string;
    email: string;
    mobile: string;
  };
  forms_sent: Array<{ title: string; url: string }>;
}

export interface CustomerRegistrationSettings {
  enabled: boolean;
  linked_form_ids: number[];
  public_url: string;
  encoded_company_id: string;
}

export async function fetchPublicRegistrationForm(
  encodedCompanyId: string
): Promise<PublicRegistrationMeta> {
  const response = await api.get<{ data: PublicRegistrationMeta }>(
    `/forms/register/${encodedCompanyId}`
  );
  return response.data.data;
}

export async function submitPublicRegistration(
  encodedCompanyId: string,
  payload: {
    name: string;
    email: string;
    mobile: string;
    calling_code?: string;
    date_of_birth?: string;
    address?: string;
    pin_code: string;
    age_confirmed: boolean;
  }
): Promise<PublicRegistrationResult> {
  const response = await api.post<{ data: PublicRegistrationResult }>(
    `/forms/register/${encodedCompanyId}`,
    payload
  );
  return response.data.data;
}

export async function getCustomerRegistrationSettings(): Promise<CustomerRegistrationSettings> {
  const response = await api.get<{ data: CustomerRegistrationSettings }>(
    "/admin/settings/customer-registration"
  );
  return response.data.data;
}

export async function updateCustomerRegistrationSettings(payload: {
  enabled: boolean;
  linked_form_ids: number[];
}): Promise<CustomerRegistrationSettings> {
  const response = await api.put<{ data: CustomerRegistrationSettings }>(
    "/admin/settings/customer-registration",
    payload
  );
  return response.data.data;
}
